// Service Worker registration and communication utilities
import { API_BASE_URL } from '../config/api';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register() {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
        navigator.serviceWorker.ready.then((registration) => {
          console.log('✅ Service worker is ready for protected assets.');
          setupMessageListener();
          sendConfigToServiceWorker();
        });
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ SW registered: ', registration);
      setupMessageListener();
      sendConfigToServiceWorker();
    })
    .catch((error) => {
      console.error('❌ SW registration failed: ', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

function sendConfigToServiceWorker() {
  if (navigator.serviceWorker.controller) {
    // Extract base URL without /api suffix for asset endpoints
    const baseUrl = API_BASE_URL.replace('/api', '');
    
    console.log('🔧 Sending API config to service worker:', { baseUrl });
    
    navigator.serviceWorker.controller.postMessage({
      type: 'SET_API_CONFIG',
      config: {
        baseUrl: baseUrl
      }
    });
  } else {
    // If no controller yet, wait for it
    navigator.serviceWorker.ready.then(() => {
      setTimeout(sendConfigToServiceWorker, 100);
    });
  }
}

function setupMessageListener() {
  console.log('🔧 Setting up service worker message listener...');
  
  // Remove any existing listeners
  navigator.serviceWorker.removeEventListener('message', handleMessage);
  
  // Add the message listener
  navigator.serviceWorker.addEventListener('message', handleMessage);
  
  console.log('✅ Service worker message listener set up');
}

function handleMessage(event) {
  console.log('📨 Received message from service worker:', event.data);
  
  if (event.data && event.data.type === 'GET_AUTH_TOKEN') {
    // Get token from localStorage and send back to service worker
    const token = localStorage.getItem('access_token');
    console.log('🔑 Sending auth token to service worker:', token ? 'Token found' : 'No token');
    
    if (event.ports && event.ports[0]) {
      event.ports[0].postMessage({ token });
    } else {
      console.error('❌ No message port available to send token');
    }
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
} 